import { type Ref, watch } from 'vue'

import { tryOnScopeDispose } from '@vueuse/core'

/**
 * Publishes a reactive px length to a CSS custom property on <html>, cleared on
 * unmount. Skips null / non-positive values so the layout.css fallback stays in
 * play (first paint, display:none). Writes only on the client — watchers don't
 * run during SSR, so `document` is never touched server-side.
 */
export function useRootPxVar(
  source: Readonly<Ref<number | null>>,
  cssVar: string,
) {
  watch(source, (value) => {
    if (value != null && value > 0)
      document.documentElement.style.setProperty(cssVar, `${value}px`)
  })

  tryOnScopeDispose(() => document.documentElement.style.removeProperty(cssVar))
}
